import clsx from 'clsx'
import type { HTMLAttributes } from 'react'
import { Trans } from '@lingui/macro'

export function Divider({
  className,
  ...props
}: HTMLAttributes<HTMLHRElement> = {}) {
  return <hr className={clsx('border-light', className)} {...props} />
}

export function OrDivider() {
  return (
    <div className="flex items-center gap-4 text-gray-500">
      <Divider className="w-full" />
      <p className="py-8">
        <Trans>or</Trans>
      </p>
      <Divider className="w-full" />
    </div>
  )
}
